{
  "comment": "M4 factions (spec §4.7, §7.7). Ids are the factions.md data ids, in this order (the order is the faction index). teamId is the M1 Team.id used locally (the player is team 0 and not listed). treasury: the starting credits. livery: the style guide §5.4 faction sheet id (operators paint). yard: shipyard preference, 'own', 'any' or a faction id (raiders buy hulls from Varro, D-TBD). active: guardian is reserved and inactive in M4 (M5 activates it). M5 adds personality weights to this file. Starting values, tune freely. E15 tuning pass (D-TBD: M4 tuning pass): starting treasuries are 10x the spec values (raiders 50x): M4 has no faction income (M5 adds tariffs, tolls, subsidies and fees), so the reserves carry each faction's structural costs (habitat upkeep, fleet replacement, imports; raider hulls bought from loot) through the soak horizon. M5 (M5 spec §4.1, plan C0): outlaw (raider, guardian: no claims, Charter money or votes), parent (the guardian cell answers to the Holdfast), escalationBias (hidden; Varro 0.9), personality weights 0..1, and the starting faction-to-faction standings (−100..100, symmetric; default for unlisted pairs; hidden pairs never reach the UI). guardian stays active: false until the guardian cell runs (C10/C11): M4 job fill reads active. Balance pass T5: orderReserve is the share of its starting treasury a faction keeps when placing a pay-on-delivery ship order (0 = off).",
  "orderReserve": 0.25,
  "factions": [
    {
      "id": "raider",
      "name": "Raider clans",
      "teamId": 1,
      "kind": "outlaw",
      "treasury": 20000000,
      "livery": "raider",
      "yard": "varro_security",
      "active": true,
      "outlaw": true,
      "parent": null,
      "personality": { "order": 0, "fees": 0, "greed": 0.7, "expansion": 0.3, "tetherstone": 0.3, "trade": 0.1, "neutrality": 0, "conflict": 0.6, "survival": 0.4, "labor": 0, "gate": 0, "opportunism": 1 }
    },
    {
      "id": "authority",
      "name": "Reach Charter Authority",
      "teamId": 2,
      "kind": "charter",
      "treasury": 60000000,
      "livery": "authority",
      "yard": "own",
      "active": true,
      "outlaw": false,
      "parent": null,
      "personality": { "order": 0.9, "fees": 0.7, "greed": 0.2, "expansion": 0.3, "tetherstone": 0.3, "trade": 0.4, "neutrality": 0.6, "conflict": 0.2, "survival": 0.5, "labor": 0.2, "gate": 0.7, "opportunism": 0.1 }
    },
    {
      "id": "tethys",
      "name": "Tethys Mining Combine",
      "teamId": 3,
      "kind": "megacorp",
      "treasury": 80000000,
      "livery": "tethys",
      "yard": "own",
      "active": true,
      "outlaw": false,
      "parent": null,
      "personality": { "order": 0.3, "fees": 0.5, "greed": 0.9, "expansion": 0.8, "tetherstone": 1, "trade": 0.5, "neutrality": 0.2, "conflict": 0.5, "survival": 0.4, "labor": 0, "gate": 0, "opportunism": 0.4 }
    },
    {
      "id": "meridian",
      "name": "Meridian Freight & Logistics",
      "teamId": 4,
      "kind": "megacorp",
      "treasury": 60000000,
      "livery": "meridian",
      "yard": "own",
      "active": true,
      "outlaw": false,
      "parent": null,
      "personality": { "order": 0.5, "fees": 0.6, "greed": 0.6, "expansion": 0.5, "tetherstone": 0.2, "trade": 0.9, "neutrality": 0.8, "conflict": 0.2, "survival": 0.4, "labor": 0.2, "gate": 0.3, "opportunism": 0.2 }
    },
    {
      "id": "varro_security",
      "name": "Varro Security Services",
      "teamId": 5,
      "kind": "megacorp",
      "treasury": 50000000,
      "livery": "varro_security",
      "yard": "own",
      "active": true,
      "outlaw": false,
      "parent": null,
      "escalationBias": 0.9,
      "personality": { "order": 0.4, "fees": 0.4, "greed": 0.7, "expansion": 0.3, "tetherstone": 0.2, "trade": 0.5, "neutrality": 0.6, "conflict": 0.9, "survival": 0.3, "labor": 0, "gate": 0.1, "opportunism": 0.5 }
    },
    {
      "id": "mutual",
      "name": "Spacers' Mutual",
      "teamId": 6,
      "kind": "independent",
      "treasury": 25000000,
      "livery": "mutual",
      "yard": "any",
      "active": true,
      "outlaw": false,
      "parent": null,
      "personality": { "order": 0.4, "fees": 0.2, "greed": 0.3, "expansion": 0.3, "tetherstone": 0.2, "trade": 0.5, "neutrality": 0.4, "conflict": 0.3, "survival": 0.8, "labor": 0.9, "gate": 0.4, "opportunism": 0.1 }
    },
    {
      "id": "holdfast",
      "name": "Holdfast",
      "teamId": 7,
      "kind": "descendant",
      "treasury": 15000000,
      "livery": "holdfast",
      "yard": "own",
      "active": true,
      "outlaw": false,
      "parent": null,
      "personality": { "order": 0.5, "fees": 0.2, "greed": 0.2, "expansion": 0.2, "tetherstone": 0, "trade": 0.4, "neutrality": 0.3, "conflict": 0.3, "survival": 0.8, "labor": 0.5, "gate": 1, "opportunism": 0.1 }
    },
    {
      "id": "guardian",
      "name": "Guardian",
      "teamId": 8,
      "kind": "outlaw",
      "treasury": 0,
      "livery": "guardian",
      "yard": "any",
      "active": false,
      "outlaw": true,
      "parent": "holdfast",
      "personality": { "order": 0.2, "fees": 0, "greed": 0, "expansion": 0, "tetherstone": 0, "trade": 0, "neutrality": 0, "conflict": 0.6, "survival": 0.6, "labor": 0.3, "gate": 1, "opportunism": 0.1 }
    }
  ],
  "standings": {
    "default": 0,
    "pairs": [
      { "a": "authority", "b": "raider", "value": -100 },
      { "a": "tethys", "b": "raider", "value": -100 },
      { "a": "meridian", "b": "raider", "value": -100 },
      { "a": "varro_security", "b": "raider", "value": -100 },
      { "a": "mutual", "b": "raider", "value": -100 },
      { "a": "holdfast", "b": "raider", "value": -100 },
      { "a": "guardian", "b": "raider", "value": -100 },
      { "a": "guardian", "b": "tethys", "value": -80 },
      { "a": "tethys", "b": "holdfast", "value": -30 },
      { "a": "tethys", "b": "mutual", "value": -10 },
      { "a": "holdfast", "b": "guardian", "value": 40, "hidden": true },
      { "a": "authority", "b": "meridian", "value": 10 },
      { "a": "authority", "b": "mutual", "value": 5 },
      { "a": "meridian", "b": "mutual", "value": 5 },
      { "a": "varro_security", "b": "tethys", "value": 5 },
      { "a": "varro_security", "b": "meridian", "value": 5 }
    ]
  }
}
